import { makeObservable, observable, action, computed, runInAction } from 'mobx';
import i18n from 'src/i18n';

export default class SectionTabsViewModel {
  @observable nowSection = 'info';
  @observable sectionList = ['info', 'chapter', 'comment'];
  @observable sectionName = [i18n.t('course_tab_intro'), i18n.t('course_tab_chapter'), i18n.t('course_tab_comments')];

  constructor() {
    makeObservable(this);
  }

  @action
  didMount = (router) => {
    const pathArr = router.location.pathname.split('/');
    const path = pathArr[pathArr.length - 1];
    this.onSectionChange(path);
  }

  @action
  onSectionChange = (sec) => {
    this.nowSection = sec;
  }
}
